// extracted by mini-css-extract-plugin
module.exports = {"container":"FavoriteDriverDetail_container__q-Emk","red":"FavoriteDriverDetail_red__12Rvg","grey":"FavoriteDriverDetail_grey__131cU","black":"FavoriteDriverDetail_black__1vLx3"};